/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Portada_Home from "./Componentes/Portada_Home";
import Caracteristicas_Home from "./Componentes/Caracteristicas_Home";
import Valores_Home from "./Componentes/Valores_Home";
import Reportes_Home from "./Componentes/Reportes_Home";
import Contactos_Home from "./Componentes/Contactos_Home";
import {useEffect} from "react";
import {useParams} from "react-router-dom";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import Formulario_Contactos_Home from "./Componentes/SubComponentes/Formulario_Contactos_Home";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Proyectos_Home from "./Componentes/Proyectos_Home";

const Seccion_Home = () => {
    const parms = useParams()
    const {sCell} = useResponsive()

    useEffect(() => {

        if (parms && parms.id === 'Contactos') {
            setTimeout(() => {
                scrolearAComponente(parms.id)
            }, 500)
        }


    }, [parms]);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}
            sx={{zIndex: 1}}
        >

            <Grid2 container size={12}>
                <Portada_Home/>
            </Grid2>

            <Grid2 container size={12} sx={{mt: sCell ? 6 : 8}}>
                <Caracteristicas_Home/>
            </Grid2>

            <Grid2 container size={12} sx={{mt: sCell ? 14 : 16}}>
                <Valores_Home/>
            </Grid2>

            <Grid2 container size={12} sx={{mt: sCell ? 14 : 16}}>
                <Proyectos_Home/>
            </Grid2>

            <Grid2 id={'Contactos'} container size={12} sx={{my: 10}}>
                <Contactos_Home/>
            </Grid2>

            <Grid2 container size={12} sx={{mt: 10}}>
                <Reportes_Home/>
            </Grid2>

            <Grid2 container size={12} sx={{mt: 14, mb: 4}}>
                <Formulario_Contactos_Home/>
            </Grid2>


        </Grid2>
    )

}
export default Seccion_Home;